export default function InstallPageTitle(NetteAjax) {
  // support $this->redirect()
  return NetteAjax.ext('page-title', {
    success: function (payload) {
      if (payload.pageTitle) {
        document.title = payload.pageTitle.join(' | ')
      }
    },
  })
}
